import object from 'helpers/object'


export const initialState = {
  order: {},
  isFetching: true,
}


export const setOrder = (state, payload) => (
  object.setIn(state, [ 'order' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
